import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { RoundedHorizontalBarChart } from '../../shared-components';
import { FlexBox } from '../../shared-components/flex-box';
import './CountryAwardStatisticSection.scss';

const CountryAwardStatisticSectionImpl: React.FC = () => {
  const {
    awardStore,
    countryAwardPageUiStore,
  } = useStores();

  return (
    <FlexBox
      direction='column'
      className='country-award-statistic-section'
    >
      <div>
        <Text
          size={400}
          weight='semibold'
        >
          Number of nominations
        </Text>
        <RoundedHorizontalBarChart
          id='submitted-nominations-count'
          primaryData={{
            name: 'Submitted',
            color: '#0078D4',
            value: countryAwardPageUiStore.submittedNominationsCount,
          }}
          secondaryData={{
            name: 'Incomplete',
            color: '#50E6FF',
            value: countryAwardPageUiStore.incompleteNominationsCount,
          }}
        />
      </div>
      <div>
        <Text
          size={400}
          weight='semibold'
        >
          Pass vs. disqualify
        </Text>
        <RoundedHorizontalBarChart
          id='passed-nominations-count'
          primaryData={{
            name: 'Pass',
            color: '#107C10',
            value: countryAwardPageUiStore.passedNominationsCount,
          }}
          secondaryData={{
            name: 'Disqualified',
            color: '#9BF00B',
            value: countryAwardPageUiStore.disqualifiedNominationsCount,
          }}
        />
        {countryAwardPageUiStore.pendingAffirmationNominationsCount > 0 && (
          <div className='pending-affirmation'>
            <Text size={300}>Pending affirmation</Text>
            <Text size={300} weight='semibold'>{countryAwardPageUiStore.pendingAffirmationNominationsCount}</Text>
          </div>
        )}
      </div>
      <div>
        <Text
          size={400}
          weight='semibold'
        >
          Judges started
        </Text>
        <RoundedHorizontalBarChart
          id='judges-active-count'
          primaryData={{
            name: 'Active',
            color: '#8661C5',
            value: awardStore.isJudgingWindowOpen ? countryAwardPageUiStore.judgesActiveCount : 0,
          }}
          secondaryData={{
            name: 'Inactive',
            color: '#D59DFF',
            value: awardStore.isJudgingWindowOpen ? countryAwardPageUiStore.judgesInActiveCount : 0,
          }}
        />
      </div>
      <div>
        <Text
          size={400}
          weight='semibold'
        >
          Judged nominations
        </Text>
        <RoundedHorizontalBarChart
          id='judged-nominations-completed-count'
          primaryData={{
            name: 'Complete',
            color: '#008575',
            value: awardStore.isJudgingWindowOpen ? countryAwardPageUiStore.judgedNominationsCompletedCount : 0,
          }}
          secondaryData={{
            name: 'Incomplete',
            color: '#30E5D0',
            value: awardStore.isJudgingWindowOpen ? countryAwardPageUiStore.judgedNominationsInProgressCount : 0,
          }}
        />
      </div>
    </FlexBox>
  );
}

export const CountryAwardStatisticSection = observer(CountryAwardStatisticSectionImpl);
